require('./reimburseInvestmentDetails.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');
// @ helpers
const { FormattedText, getLanguage } = require('core/i18n').i18n;
const { toCamelCase } = require('utilities/stringHelper');
const DateHelper = require('utilities/dateHelper');
const { formatAmount, getFormattedString, formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
const IbanHelper = require('utilities/ibanHelper');
// @ components
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
// @ constants
const { API_ENTERPRISE_NUMBER, API_CENTER } = require('constants/index');
const {
    DATE_FORMAT_ES,
    FIRST_STEP,
    BROKER_FUNDS_REIMBURSE_CONTRACT_FORMAT,
    BROKER_REIMBURSE_FUND_TOTAL,
} = require('constants/index');
const {
    WEALTH_FUNDS_PARTIAL_REIMBURSEMENT
} = require('constants/flagBasedFeatures');
class ReimburseInvestmentDetails extends React.Component {
    render() {
        const { immReimburseInvestment, isSuccess, immFlagBasedFeatures} = this.props;
        const reimburseFund = immReimburseInvestment.getIn(['steps', FIRST_STEP,'reimburseFund']);
        const immAccount = reimburseFund.get('account');
        const accountContractNumber = immAccount.get('contractNumber');
        const accountProductNumber = immAccount.get('product');
        const accountCodbban = immAccount.getIn(['ibanComplex', 'codbban']);
        const accountControlDigit = accountCodbban.substring(8, 10);
        const fullAccountNumber = IbanHelper.formatAccountTextWithSpaces(
            `${API_ENTERPRISE_NUMBER}${API_CENTER}${accountControlDigit}${accountProductNumber}${accountContractNumber}`,
            BROKER_FUNDS_REIMBURSE_CONTRACT_FORMAT
        );
        const accountHolder = immAccount.get('accountHolder');
        const accountAlias = immAccount.getIn(['alias']);
        const fundContractNumber = reimburseFund.get('contractNumber');
        const fundProductNumber = reimburseFund.get('productNumber');
        const fundControlDigit = reimburseFund.get('fundControlDigit');
        const fullFundContractNumber = IbanHelper.formatAccountTextWithSpaces(
            `${API_ENTERPRISE_NUMBER}${API_CENTER}${fundControlDigit}${fundProductNumber}${fundContractNumber}`,
            BROKER_FUNDS_REIMBURSE_CONTRACT_FORMAT,
        );
        const fundName = immReimburseInvestment.getIn(['steps', FIRST_STEP, 'reimburseInvestment','name']);
        const isTotal = immReimburseInvestment.getIn(['steps', FIRST_STEP, 'type']) === BROKER_REIMBURSE_FUND_TOTAL;
        let participations;

        if (isTotal) {
            participations = formatAmount(reimburseFund.get('fundParticipations'), null, 5);
        } else {
            const ffFundsPartialReimbursement = immFlagBasedFeatures.get(WEALTH_FUNDS_PARTIAL_REIMBURSEMENT);
            const customCategoryId2 = immReimburseInvestment.getIn(['steps', 0, 'reimburseInvestment', 'customCategoryId2']);
            const amount =
            ffFundsPartialReimbursement && customCategoryId2 === '2'
                ? immReimburseInvestment.getIn(['steps', FIRST_STEP, 'participationAmount'])
                : immReimburseInvestment.getIn(['steps', FIRST_STEP, 'amount']);
            const amountObject = {
                amount: amount,
                currency: reimburseFund.get('currencyFund')
            };
            const plainAmountObject = getPlainAmountObject(amountObject);

            participations = (
                <OneLineSymbolAmount
                    amountObject={plainAmountObject}
                    language={getLanguage()}
                    amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
            )
        }

        const lastNetAssetValue = reimburseFund.get('lastNetAssetValue');
        const netAssetDayEndDate = immReimburseInvestment.getIn(['steps', FIRST_STEP, 'reimburseInvestment', 'netAssetValue', 'dayEndDate']);
        const labelNetAssetDate = DateHelper.buildFormattedDate(moment(netAssetDayEndDate), DATE_FORMAT_ES);
        const labelDate = DateHelper.buildFormattedDate(moment(), DATE_FORMAT_ES);

        const classDiv = isSuccess ? '' : 'reimburse-investment-details__right-border';

        const sellType = isTotal
            ? <FormattedText value="reimburseInvestmentDetails-total"/>
            : <FormattedText value="reimburseInvestmentDetails-partial"/>
        const headerParticipations = isTotal
            ? <FormattedText value="reimburseInvestmentDetails-participations"/>
            : <FormattedText value="reimburseInvestmentDetails-importe"/>

        return (
            <div className="reimburse-investment-details">
                <div className="row">
                    <div className="reimburse-investment-details">
                        <div className="row">
                            <div className={"reimburse-investment-details__text col-lg-3 reimburse-investment-details__name " + classDiv}>
                                <FormattedText value="reimburseInvestmentDetails-investmentFund"/>
                                <div className="reimburse-investment-details__bold">{fundName}</div>
                                <FormattedText value="reimburseInvestmentDetails-type"/>
                                <div className="reimburse-investment-details__bold">{sellType}</div>
                            </div>
                            <div
                                className={
                                    'reimburse-investment-details__text col-lg-3 ' + classDiv
                                }
                            >
                                <div>
                                    <FormattedText
                                        value="reimburseInvestmentDetails-contract"
                                        className="reimburse-investment-details__text"
                                    />

                                    <div className="reimburse-investment-details__bold">
                                        {toCamelCase(accountAlias)}
                                    </div>
                                    <div>
                                        {fullAccountNumber}
                                    </div>
                                </div>
                                <div className="reimburse-investment-details__contract-number">
                                    <FormattedText
                                        value="reimburseInvestmentDetails-contractNumber"
                                        className="reimburse-investment-details__bold"
                                        injectedStrings={[
                                            fullFundContractNumber
                                        ]}
                                    />
                                </div>
                                <div>
                                    <FormattedText
                                        value="reimburseInvestmentDetails-holder"
                                        className="reimburse-investment-details__text"
                                        injectedStrings={[accountHolder]}
                                    />
                                </div>
                            </div>
                            <div
                                className={
                                    'reimburse-investment-details__text col-lg-2 reimburse-investment-details__participations ' + classDiv
                                }
                            >
                                {headerParticipations}
                                <div className="reimburse-investment-details__bold">
                                    {participations}
                                </div>
                            </div>
                            <div
                                className={
                                    'reimburse-investment-details__text col-lg-2 reimburse-investment-details__value ' + classDiv
                                }
                            >
                                <FormattedText
                                    value="reimburseInvestmentDetails-lastLiquidatedValue"
                                    injectedStrings={[labelNetAssetDate]}
                                />
                                <div className="reimburse-investment-details__bold">
                                    {getFormattedString(lastNetAssetValue)}
                                </div>
                            </div>
                            <div className="reimburse-investment-details__text col-lg-2">
                                <FormattedText value="reimburseInvestmentDetails-date" />
                                <div className="reimburse-investment-details__bold">
                                    {labelDate}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ReimburseInvestmentDetails.propTypes = {
    immReimburseInvestment: PropTypes.object.isRequired,
    isSuccess: PropTypes.bool
};
module.exports = ReimburseInvestmentDetails;
